<template>
	<Question :demo="demo">
		<template v-slot:question>
			À quel secteur d'activité appartenez-vous ?
		</template>

		<template v-slot:aide>
			Si vous ne savez pas, vous pouvez consulter <a href="https://ghs.fr/IMG/pdf/COVID2-ListeSecteurs.pdf" target="_blank">la liste des secteurs</a>.
		</template>

		<template v-slot:input>
			<b-field v-for="sect in secteurs" :key="sect.value">
				<b-radio
					v-model="secteur"
					:native-value="sect.value"
					:disabled="demo"
				>
					<span v-html="sect.label"></span>
				</b-radio>
			</b-field>
		</template>
	</Question>
</template>

<script>
import Question from '@/components/Question.template.vue'

export default {
	components: {
		Question,
	},

	name: 'QSecteur',

	props: {
		demo: Boolean,
	},

	data: () => ({
		secteurs: [
			{ value: "S1", label: "Secteur <strong>S1</strong>" },
			{ value: "S1bis", label: "Secteur <strong>S1bis</strong>" },
			{ value: "S2", label: "Secteur <strong>S2</strong>" },
			{ value: "aucun", label: "Je ne suis dans aucun des secteurs référencés" },
		],
	}),

	computed: {
		secteur: {
			get () {
				return this.$store.state.m2.secteur
			},
			set (secteur) {
				this.$store.commit('m2/setSecteur', secteur)
			}
		},
	},
}
</script>

<style scoped>

</style>
